import { Observable } from 'rxjs';
import { FaqOverviewResponse } from '../../model/faq-items.model';

export abstract class FaqOverviewAdapter {
  abstract loadOverview(
    isUserLoggedIn: boolean, searchTerm: string
  ): Observable<FaqOverviewResponse>;
}
